export default "__VITE_ASSET__C1iNAWoa__"